import Vue from 'vue';
import { errorHandler } from '../../../helpers/helpers';
import * as types from '../../types/instrucao-trabalho.types';

export default {
  namespaced: true,
  state: {
    carregando: true,
    data: [],
  },
  getters: {
    carregando: state => state.carregando,
    getITData: state => state.data,
  },
  mutations: {
    [types.INSTRUCAO_TRABALHO](state, payload) {
      state.data = payload;
      state.carregando = false;
    },
  },
  actions: {
    instrucaoTrabalho({ commit, state }) {
      state.carregando = true;
      state.data = [];
      Vue.http
        .get(
          `${process.env.VUE_APP_API_URL}/revista-online/instrucao-trabalho?limit=7&modulo=revista`,
        )
        .then(
          ({ data: { data } }) => {
            commit(types.INSTRUCAO_TRABALHO, data);
          },
          err => errorHandler(err),
        );
    },
  },
};
